import { hashLocalPassword } from '../../../kernel/localPasswordHash.ts';

/** Pull row: plain `password` → `passwordHash` via {@link hashLocalPassword} before SQLite merge. */
export async function normalizeSyncUsuarioSections(
  sections: Readonly<Record<string, unknown>>,
): Promise<Record<string, unknown>> {
  const raw = sections.usuarios;
  if (!Array.isArray(raw) || raw.length === 0) return { ...sections };
  const usuarios = await Promise.all(raw.map((row) => normalizeSyncUsuarioRow(row)));
  return { ...sections, usuarios };
}

async function normalizeSyncUsuarioRow(row: unknown): Promise<unknown> {
  if (!row || typeof row !== 'object') return row;
  const r = row as Record<string, unknown>;
  const plain = typeof r.password === 'string' ? r.password.trim() : '';
  if (!plain) return row;
  const { password: _password, ...rest } = r;
  const sha1Hex = /^[a-f0-9]{40}$/i;
  if (sha1Hex.test(plain)) return { ...rest, passwordHash: plain.toLowerCase() };
  return { ...rest, passwordHash: await hashLocalPassword(plain) };
}
